import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import 'reflect-metadata';
import '@/sass/index.scss';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import App from '@/pages/App';
import {ConfigProvider} from 'antd';
import {pdfjs} from 'react-pdf';
import {COLOR} from '@/constants';
import {styleTableGlobal} from '@/configs/table-config';
import {FileListProvider} from '@/contexts/FileContext';
import {AllCommunityModule, ModuleRegistry} from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

// import pdf worker
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ''}/pdf.worker.min.js`;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {colorPrimary: COLOR.bgLight, fontFamily: 'Roboto'},
        hashed: false,
        components: {
          Table: styleTableGlobal,
        },
      }}
    >
      <FileListProvider>
        <App />
      </FileListProvider>
    </ConfigProvider>
  </React.StrictMode>,
);
